import styled from '@emotion/styled';
import TabComponent from '@mui/material/Tab';
import { ReactComponent as CrossSimpleIconComponent } from 'assets/icons/cross-simple.svg';
import { css } from '@emotion/react';
import { Colors } from '../../styles/variables/colors';
import { Variables } from '../../styles/variables/variables';
import { TextStyle } from 'styles/variables/mixins';

const { white, formBackground, blue, lightBlue, gray, darkGray, green } = Colors;
const { montserrat } = Variables;

export const Assessment = styled.div<{ asmnt: boolean }>`
    ${({ asmnt }) =>
        asmnt
            ? css`
                  max-width: 1256px;
                  background-color: white;
                  padding: 20px;
                  margin: auto;
                  margin-top: 150px;
                  min-height: 100vh;
              `
            : ''}
`;

export const Badge = styled.div`
    ${TextStyle({ fontSize: '13px', fontWeight: '500', color: white })}
    display: flex;
    align-items: center;
    height: 26px;
    background: ${green};
    border-radius: 3px;
    padding: 2px 14px 2px 10px;
    font-style: normal;
    line-height: 16px;
`;

export const ButtonContainer = styled.span`
    display: flex;
    gap: 64px;

    @media screen and (max-width: 501px) {
        flex-direction: column;
        gap: 27px;
    }
`;

export const CollectionItemBadge = styled.div`
    ${TextStyle({ fontSize: '14px', fontWeight: '600', color: white })}
    border-radius: 4px;
    width: 45.12px;
    min-width: 45.12px;
    height: 25px;
    font-style: normal;
    line-height: 17px;
    text-align: center;
    text-transform: capitalize;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CollectionItemBody = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const CollectionItemHeader = styled.div`
    ${TextStyle({ fontSize: '12px', fontWeight: '500', color: gray })}
    font-style: normal;
    line-height: 15px;
    text-transform: capitalize;
`;

export const CollectionItemText = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '500' })}
    font-style: normal;
    line-height: 18px;
    text-transform: capitalize;
`;

export const CrossSimpleIcon = styled(CrossSimpleIconComponent)`
    fill: ${darkGray};
`;

export const EditContainer = styled.span`
    display: flex;
    align-items: center;
`;

export const EditProfile = styled.p`
    margin-left: 1.25rem;
    font-family: ${montserrat};
`;

export const FooterBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const FooterDescription = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    font-style: normal;
    line-height: 22px;
`;

export const FooterIcon = styled.div`
    padding: 25px;
`;

export const FooterTitle = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '600' })}
    display: flex;
    align-items: center;
    gap: 10px;
    line-height: 22px;
`;

export const Gap = styled.div`
    display: flex;
    column-gap: 2.75rem;
    margin-bottom: 2.5rem;
`;

export const ItemBody = styled.div`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    font-style: normal;
    line-height: 18px;
`;

export const ItemHeader = styled.div`
    ${TextStyle({ fontSize: '16px', fontWeight: '600' })}
    display: flex;
    align-items: center;
    gap: 15px;
    font-style: normal;
    line-height: 20px;
`;

export const ItemHeaderBig = styled.div`
    ${TextStyle({ fontSize: '18px', fontWeight: '500' })}
    font-style: normal;
    line-height: 22px;
    text-transform: capitalize;
`;

export const Modal = styled.div`
    padding: 32px 24px;
    position: relative;
    width: 100%;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    overflow: hidden;

    &:focus-visible {
        outline: none;
    }
`;

export const ModalBtnWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 488px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background: ${white};
`;

export const ProgramScore = styled.div`
    ${TextStyle({ fontSize: '18px', fontWeight: '400' })}
    font-style: normal;
    line-height: 18px;
`;

export const ReportBody = styled.div<{ asmnt: boolean }>`
    min-width: 500px;
    max-width: 940px;
    width: 500px;

    ${({ asmnt }) =>
        asmnt
            ? css`
                  width: 100% !important;
              `
            : ''}

    @media screen and (max-width: 1600px) {
        width: 100%;
    }

    @media screen and (max-width: 768px) {
        min-width: 320px;
    }
`;

export const ReportBodyFooter = styled.div`
    display: flex;
    align-items: center;
    background: ${formBackground};
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
`;

export const ReportBodyItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ReportBodyItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ReportBodyTitle = styled.div`
    ${TextStyle({ fontSize: '28px', fontWeight: '700' })}
    font-style: normal;
    line-height: 34px;
    text-transform: capitalize;
    margin-bottom: 40px;
`;

export const ReportContainer = styled.div`
    display: flex;
    gap: 64px;
    @media screen and (max-width: 1024px) {
        flex-direction: column;
        gap: 40px;
    }
`;

export const SideBarCollection = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 44px;
`;

export const SideBarCollectionBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 20px 0px;

    @media screen and (max-width: 1024px) {
        flex-direction: row;
        flex-wrap: wrap;
        > div {
            width: 49%;
            display: flex;
            flex-wrap: wrap;
        }
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        > div {
            width: 100%;
        }
    }
`;

export const SideBarCollectionHeader = styled.div`
    ${TextStyle({ fontSize: '22px', fontWeight: '600' })}
    display: flex;
    gap: 15px;
    font-style: normal;
    line-height: 27px;
    text-transform: capitalize;
`;

export const SideBarCollectionItem = styled.div<{ active: boolean }>`
    background: ${formBackground};
    border-radius: 3px;
    padding: 12px 16px 10px;
    display: flex;
    flex-direction: column;
    &:hover {
        background-color: #ece4fc;
        cursor: pointer;
    }
    ${({ active }) =>
        active &&
        css`
            background: ${lightBlue};
            border-left: 2px solid ${blue};
            border-radius: 3px;
        `}
`;

export const SideBarReport = styled.div`
    width: 270px;
    min-width: 270px;
    @media screen and (max-width: 1024px) {
        width: 100%;
    }
`;

export const Tab = styled(TabComponent)`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    border: 2px solid ${lightBlue} !important;
    border-radius: 4px !important;
    font-size: 15px;
    font-weight: 500;
    font-family: ${montserrat};
    transition: 0.3s;

    &:hover {
        color: ${white};
        background: ${blue};
        transition: 0.3s;
    }

    &:active {
        box-shadow:
            0px 2px 1px -1px rgba(0, 0, 0, 0.2),
            0px 1px 1px 0px rgba(0, 0, 0, 0.14),
            0px 1px 3px 0px rgba(0, 0, 0, 0.12);
        transform: translateY(2px);
    }
`;
